import { useMedia } from '../../hooks/useMedia';

const widthBreakpoints = {
  narrow: 375,
  medium: 620,
  wide: 1024,
  mediumWide: 1366,
  extraWide: 1512,
  extraExtraWide: 1800,
};

/* Larger Than: "mobile-first" */

export const useIsLargerThanExtraExtraWide = (): boolean => {
  //(width >= 1800px)
  return useMedia(`(min-width: ${widthBreakpoints.extraExtraWide}px) and (min-height: 500px)`);
};

export const useIsLargerThanExtraWide = (): boolean => {
  //(width >= 1512px)
  return useMedia(`(min-width: ${widthBreakpoints.extraWide}px) and (min-height: 500px)`);
};

export const useIsLargerThanMediumWide = (): boolean => {
  //(width >= 1366px)
  return useMedia(`(min-width: ${widthBreakpoints.mediumWide}px) and (min-height: 500px)`);
};

export const useIsLargerThanWide = (): boolean => {
  //(width >= 1024px), (height >= 500px)
  return useMedia(`(min-width: ${widthBreakpoints.wide}px) and (min-height: 500px)`);
};

export const useIsLargerThanMedium = (): boolean => {
  //(width >= 620px)
  return useMedia(`(min-width: ${widthBreakpoints.medium}px)`);
};

export const useIsLargerThanNarrow = (): boolean => {
  //(width >= 375px)
  return useMedia(`(min-width: ${widthBreakpoints.narrow}px)`);
};

/* Smaller Than: "desktop-first" */

export const useIsSmallerThanExtraExtraWide = (): boolean => {
  //(width < 1800px)
  return useMedia(`(max-width: ${widthBreakpoints.extraExtraWide - 1}px), (max-height: 499px)`);
};

export const useIsSmallerThanExtraWide = (): boolean => {
  //(width < 1512px)
  return useMedia(`(max-width: ${widthBreakpoints.extraWide - 1}px), (max-height: 499px)`);
};

export const useIsSmallerThanMediumWide = (): boolean => {
  //(width < 1366px)
  return useMedia(`(max-width: ${widthBreakpoints.mediumWide - 1}px), (max-height: 499px)`);
};

export const useIsSmallerThanWide = (): boolean => {
  //(width < 1024px), (height < 500px)
  return useMedia(`(max-width: ${widthBreakpoints.wide - 1}px), (max-height: 499px)`);
};

export const useIsSmallerThanMedium = (): boolean => {
  //(width < 620px)
  return useMedia(`(max-width: ${widthBreakpoints.medium - 1}px)`);
};

export const useIsSmallerThanNarrow = (): boolean => {
  //(width < 375px)
  return useMedia(`(max-width: ${widthBreakpoints.narrow - 1}px)`);
};

export const useIsCompressed = (): boolean => {
  //(height < 320px), (width < 360px)
  return useMedia('(max-height: 319px), (max-width: 359px)');
};

export const useIsUncompessed = (): boolean => {
  //(height >= 320px) and (width >= 360px)
  return useMedia('(min-height: 320px) and (min-width: 360px)');
};

export const useIsLandscape = (): boolean => {
  return useMedia('(orientation: landscape)');
};

export const useIsPortrait = (): boolean => {
  return useMedia('(orientation: portrait)');
};
